import Vue from 'vue'
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'
import { library } from '@fortawesome/fontawesome-svg-core'

import { faCogs, faDotCircle, faTimesCircle,faGreaterThan} from '@fortawesome/free-solid-svg-icons'

library.add(faCogs, faDotCircle,faTimesCircle,faGreaterThan)

Vue.component('font-awesome-icon', FontAwesomeIcon)